import React, {FC, ReactElement} from 'react';
import styles from './index.module.scss';
import {useTranslation} from "react-i18next";

interface Props {
    onClose: () => void
}

const CertificationTipsModal: FC<Props> = ({onClose}): ReactElement => {
    const {t} = useTranslation();
    return (
        <div className={styles.modal}>
            <div className={styles.overlayCss} onClick={() => onClose()}></div>
            <div className={styles.contentCss}>
                <div style={{padding: '0.16rem', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <p>{t('home.toPassVerificationMoreEasily')}</p>
                    <img src={require('img/certification_tips.png').default} alt=""/>
                </div>

                <div className={styles.line}></div>
                <div className={styles.confirm} onClick={() => onClose()}>{t('home.Acknowledged')}</div>
            </div>
        </div>
    )
}

export default CertificationTipsModal
